import React from 'react';
import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle';
import NavbarLink from './navbar-link';
import NavbarLinkSection from './navbar-link-section';
import * as routes from '../../common/constants.ts';

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.innerWidth <= 992,
    };

    this.updateViewport = this.updateViewport.bind(this);
  }

  handleReload = (e) => {
    // e.preventDefault();
    // window.location.href = e.currentTarget.href;
    // window.location.reload();
    // $('.site-header .site-menu>ul>li.has-megamenu').addClass("no-after-pseudo-prop");
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateViewport);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateViewport);
  }

  updateViewport() {
    this.setState({ isMobile: window.innerWidth <= 992 });
  }

  handleMenuToggle = (e) => {
    e.stopPropagation();

    //chequea si la pagina esta en version mobile para activar/desactivar el colapso (animacion de apertura) del menu hamburguesa
    if (this.state.isMobile) {
      // Handle collapse toggle only if on mobile
      const target = e.currentTarget;
      const isActive = target.getAttribute('data-toggle') === 'collapse';
      target.setAttribute('data-toggle', isActive ? null : 'collapse');
    }

    if (
      e.currentTarget.firstElementChild &&
      e.currentTarget.firstElementChild.tagName.toLowerCase() === 'a'
    ) {
      //quita la clase "active-nav-item" de todos los links padre de la navbar
      const hasMegaMenuElements = document.getElementsByClassName('has-megamenu');
      for (let item of hasMegaMenuElements) {
        item.classList.remove('active-nav-item');
        item.classList.remove('open-nav-item');
      }

      //le agrega la clase "active-nav-item" al link padre del submenu al que se haya entrado (eg. si clickeo Resmas Multifuncion, Papel se pondra como activo)
      let parentNavButton = e.currentTarget.closest('.has-megamenu');
      parentNavButton.classList.add('active-nav-item');
    }

    //esconde el menu desplegable de la navbar cuando se clickea un link
    const megaMenuElements = document.getElementsByClassName('mega-menu');
    for (let item of megaMenuElements) {
      item.style.display = 'none';
      setTimeout(() => {
        item.style.display = '';
      }, 100);
    }
  };

  handleOpenMenuForMobile = (e) => {
    //maneja la apertura/cerrado del desplegable de la navbar para dispositivos touch usando la version desktop
    if (e.currentTarget.classList.contains('open-nav-item')) {
      e.currentTarget.classList.remove('open-nav-item');
      e.currentTarget.classList.remove('active-nav-item');
    } else {
      const hasMegaMenuElements = document.getElementsByClassName('has-megamenu');
      for (let item of hasMegaMenuElements) {
        item.classList.remove('open-nav-item');
        item.classList.remove('active-nav-item');
      }
      e.currentTarget.classList.add('open-nav-item');
      e.currentTarget.classList.add('active-nav-item');
    }
  };

  render(props) {
    return (
      <div className="navbar" id="navbar">
        {/* Main Navigation*/}
        <nav id="navsitemenu" className="site-menu">
          <ul id="ulnavbar">
            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link to="/productLane/00000002">Papel</Link>
              <ul className="mega-menu">
                <NavbarLinkSection
                  sectionText="Resmas"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Resmas Multifunción"
                    url={routes.resmas_multifuncionRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Resmas Color"
                    url={routes.Resmas_colorRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Papeles especiales"
                    url={routes.Papeles_especialesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Formulario continuo"
                    url={routes.Formulario_continuoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Cuadernos y Blocks"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Cuadernos"
                    url={routes.CuadernosRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Blocks"
                    url={routes.BlocksRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Cuadernillos"
                    url={routes.CuadernillosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Repuesto cuadernos"
                    url={routes.Repuesto_cuadernosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Block para rotafolio"
                    url={routes.Block_para_rotafolioRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Sobres y Comerciales"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Sobres manila"
                    url={routes.Sobres_manilaRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Sobres papel obra"
                    url={routes.Sobres_papel_obraRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Sobres plásticos"
                    url={routes.Sobres_plasticosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Formularios"
                    url={routes.FormulariosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Libros Comerciales"
                    url={routes.Libros_comercialesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Rollos"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Rollos Maq Sumar"
                    url={routes.Rollos_Maq_SumarRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Rollos fax"
                    url={routes.Rollos_faxRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Rollos papel film"
                    url={routes.Rollos_papel_filmRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Rollos Contact"
                    url={routes.Rollos_ContactRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Rollos de PVC"
                    url={routes.Rollos_de_PVCRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Rollos para plotters"
                    url={routes.Rollos_para_plottersRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Resmas"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Papel Carbónico"
                    url={routes.Papel_CarbonicoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Papel madera"
                    url={routes.Papel_maderaRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Papel misionero"
                    url={routes.Papel_misioneroRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Cartulina"
                    url={routes.CartulinaRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Papel comercio"
                    url={routes.Papel_comercioRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Papel de forrar"
                    url={routes.Papel_de_forrarRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Papel de Calcar"
                    url={routes.Papel_de_CalcarRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Papel para dibujo"
                    url={routes.Papel_para_dibujoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Otros"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Etiquetas"
                    url={routes.EtiquetasRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tacos de papel"
                    url={routes.Tacos_de_papelRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tacos calendarios"
                    url={routes.Tacos_calendariosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Lomo para biblioratos"
                    url={routes.Lomo_para_biblioratosRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Talonarios"
                    url={routes.TalonarioRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Ojalillos"
                    url={routes.OjalillosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Hojas para plastificar"
                    url={routes.Hojas_para_plastificarRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Transparencias"
                    url={routes.TransparenciasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>

                <li
                  data-toggle={this.state.isMobile ? 'collapse' : null}
                  onClick={(e) => this.handleMenuToggle(e)}
                  data-target="#navsitemenu"
                >
                  <Link className="tw-w-[250px] tw-h-[350px] tw-flex tw-items-center tw-justify-center tw-shrink-0" to="/productType/Resmas_multifuncion">
                    <img
                      className="tw-w-full tw-h-full tw-object-contain"
                      alt="Resma A4 Autor"
                      title='comprar resmas'
                      src="/img/banners/papel-impresionismo.webp"
                    />
                  </Link>
                </li>
              </ul>
            </li>
            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link to="/productLane/00000001">Escritura</Link>
              <ul className="mega-menu">
                <NavbarLinkSection
                  sectionText="Tinta"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Boligrafos"
                    url={routes.BoligrafosRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Rollers"
                    url={routes.RollersRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Lapiceras"
                    url={routes.LapiceraRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Correctores"
                    url={routes.CorrectoresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Lápiz"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Lapices"
                    url={routes.LapicesRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Portaminas"
                    url={routes.PortaminasRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Minas"
                    url={routes.MinasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Lapices de color"
                    url={routes.Lapices_de_colorRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Sacapuntas"
                    url={routes.SacapuntasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Gomas"
                    url={routes.GomasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Marcador"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Resaltadores"
                    url={routes.ResaltadoresRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Marcadores"
                    url={routes.MarcadoresRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Correctores"
                    url={routes.CorrectoresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tinta para marcadores"
                    url={routes.Tinta_para_marcadoresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Borrado"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Correctores"
                    url={routes.CorrectoresRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Gomas"
                    url={routes.GomasRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Repuestos"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Minas"
                    url={routes.MinasRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tanque para Roller Ball"
                    url={routes.Tanque_para_Roller_ballRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tanque para boligrafo"
                    url={routes.Tanque_para_boligrafoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Cartucho para lapicera"
                    url={routes.Cartucho_para_lapiceraRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tinta para marcadores"
                    url={routes.Tinta_para_marcadoresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Otros"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Set de escritura"
                    url={routes.Set_de_escrituraRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tizas"
                    url={routes.TizasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <li
                  data-toggle={this.state.isMobile ? 'collapse' : null}
                  onClick={(e) => this.handleMenuToggle(e)}
                  data-target="#navsitemenu"
                >
                  <Link className="tw-w-[250px] tw-h-[350px] tw-flex tw-items-center tw-justify-center tw-shrink-0" to="/productType/Marcadores">
                    <img
                      className="tw-w-full tw-h-full tw-object-contain"
                      alt="Marcador Edding 130"
                      src="/img/banners/lapices-colores-impresionismo.webp"
                      title='comprar marcadores, boligrafos'
                    />
                  </Link>
                </li>
              </ul>
            </li>
            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link to="/BuscadorInsumos">Toner y Cartuchos</Link>
              <ul className="mega-menu">
                <NavbarLinkSection
                  sectionText="Toner, Cartuchos tinta"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Toner, Cartuchos tinta, Insumos de impresión"
                    url={routes.buscadorInsumosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Cinta Para Matriz de punto"
                    url={routes.Cinta_Para_Matriz_de_puntoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <li
                  data-toggle={this.state.isMobile ? 'collapse' : null}
                  onClick={(e) => this.handleMenuToggle(e)}
                  data-target="#navsitemenu"
                  className="tw-flex tw-justify-end tw-p-0 tw-mr-3"
                >
                  <Link
                    className="tw-flex tw-items-center tw-justify-end tw-h-[350px] tw-p-0 tw-mr-3"
                    to="/BuscadorInsumos"
                  >
                    <img
                      className="tw-h-[350px] tw-w-auto tw-object-contain tw-p-0 tw-m-0"
                      alt="Toner HP"
                      src="/img/banners/toner-impresionismo.webp"
                      title="comprar toners y cartuchos, insumos de impresora"
                    />
                  </Link>
                </li>
              </ul>
            </li>

            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link to="/productLane/00000003">Informática</Link>
              <ul className="mega-menu">
                {/* <li data-toggle="collapse" data-target="#navsitemenu">
                  <span className="mega-menu-title">Toner, Cartuchos tinta</span>
                  <ul className="sub-menu">
                    <li data-toggle="collapse" data-target="#navsitemenu">
                      <Link  to="/BuscadorInsumos">Toner, Cartuchos tinta, Insumos de impresión</Link>
                    </li>
                    <li data-toggle="collapse" data-target="#navsitemenu">
                      <Link  to="/productType/Cinta_Para_Matriz_de_punto">Cinta Para Matriz de punto</Link>
                    </li>
                  </ul>
                </li> */}
                <NavbarLinkSection
                  sectionText="Computadoras"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Notebooks"
                    url={routes.NotebooksRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Periféricos"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Monitores"
                    url={routes.MonitoresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Mouse"
                    url={routes.MouseRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Teclados"
                    url={routes.TecladosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Web Cam"
                    url={routes.Web_CamRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Auriculares"
                    url={routes.AuricularesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Parlantes"
                    url={routes.ParlantesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Pad mouse"
                    url={routes.Pad_mouseRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Almacenamiento"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="CDs"
                    url={routes.CDsRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="DVD"
                    url={routes.DVDRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Memorias"
                    url={routes.MemoriasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Cinta back up"
                    url={routes.Cinta_back_upRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta CDs"
                    url={routes.Porta_CDsRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta DVDs"
                    url={routes.Porta_DVDsRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta diskettes"
                    url={routes.Porta_diskettesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Accesorios"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Mochilas"
                    url={routes.MochilasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Otros"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Power Bank"
                    url={routes.Power_BankRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Cables"
                    url={routes.CablesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Filtros monitor"
                    url={routes.Filtros_monitorRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Fundas"
                    url={routes.FundasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Aire Comprimido"
                    url={routes.Aire_ComprimidoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Copy holder"
                    url={routes.Copy_holderRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Brazos Porta Monitor"
                    url={routes.Brazos_Porta_MonitorRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Herramientas"
                    url={routes.HerramientasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>

                <li
                  data-toggle={this.state.isMobile ? 'collapse' : null}
                  onClick={(e) => this.handleMenuToggle(e)}
                  data-target="#navsitemenu"
                >
                  <Link className="tw-w-[250px] tw-h-[350px] tw-flex tw-items-center tw-justify-center tw-shrink-0" to="/productType/Notebooks">
                    <img className="tw-w-full tw-h-full tw-object-contain" alt="Notebook HP" title='comprar notebooks, informatica' src="/img/banners/notebook-impresionismo.webp" />
                  </Link>
                </li>
              </ul>
            </li>
            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link to="/productLane/00000005">Básicos</Link>
              <ul className="mega-menu">
                <NavbarLinkSection
                  sectionText="Abrochadoras y Perforadoras"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Abrochadoras"
                    url={routes.AbrochadorasRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Perforadoras"
                    url={routes.PerforadorasRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Sacabroches"
                    url={routes.SacabrochesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Repuesto perforadoras"
                    url={routes.Repuesto_perforadorasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Broches, Clips y Otros"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Broches para abrochadora"
                    url={routes.Broches_para_abrochadorasRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Clips"
                    url={routes.ClipsRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Aprieta papel"
                    url={routes.Aprieta_papelRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Broches dos puntas"
                    url={routes.Broches_dos_puntasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Broches Nepaco"
                    url={routes.Broches_NepacoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Broches Nixso"
                    url={routes.Broches_NixsoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Aros"
                    url={routes.ArosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Arandelas"
                    url={routes.ArandelasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Chinches"
                    url={routes.ChinchesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Alfileres"
                    url={routes.AlfileresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Señaladores"
                    url={routes.SeñaladoresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Básicos Oficina"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Adhesivos"
                    url={routes.AdhesivosRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Cintas adhesivas"
                    url={routes.Cintas_adhesivasRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Cesto"
                    url={routes.CestoRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tijeras"
                    url={routes.TijerasRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Almohadillas"
                    url={routes.AlmohadillasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Sellos"
                    url={routes.SellosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tinta para sellos"
                    url={routes.Tinta_para_sellosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Reglas"
                    url={routes.ReglasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Mojadedos"
                    url={routes.MojadedosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Pincha Papeles"
                    url={routes.Pincha_papelesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Banderitas señaladoras"
                    url="00000072"
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Elementos de Escritorio"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Organizadores de Escritorio"
                    url={routes.Organizadores_de_EscritorioRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Bandeja porta papeles"
                    url={routes.Bandeja_porta_papelesRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta lápiz"
                    url={routes.Porta_lapizRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta clips"
                    url={routes.Porta_clipsRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta taco"
                    url={routes.Porta_tacoRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta taco calendario"
                    url={routes.Porta_taco_calendarioRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta rollo"
                    url={routes.Porta_rolloRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Portasellos"
                    url={routes.PortasellosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Posasobres"
                    url={routes.PosasobresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Abrecartas"
                    url={routes.AbrecartasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Accesorios"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Cintas máquinas escribir"
                    url={routes.Cintas_maquinas_escribirRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Agendas"
                    url={routes.AgendasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Repuesto agenda"
                    url={routes.Repuesto_agendaRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Pilas"
                    url={routes.PilasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Revistero"
                    url={routes.RevisteroRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Cofres"
                    url={routes.CofresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta credencial"
                    url={routes.Porta_credencialRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tubo Porta Plano"
                    url={routes.Tubo_Porta_PlanoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Detector de Billetes"
                    url={routes.Detector_de_BilletesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Lupas"
                    url={routes.LupasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Empaque"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Cintas embalaje"
                    url={routes.Cintas_embalajeRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Bandas elásticas"
                    url={routes.Bandas_elasticasRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Cortantes"
                    url={routes.CortantesRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Repuesto cortante"
                    url={routes.Repuesto_cortanteRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Hilos"
                    url={routes.HilosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta rollo c. embalaje"
                    url="00000108"
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Bolsas"
                    url={routes.BolsasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>

                <li
                  data-toggle={this.state.isMobile ? 'collapse' : null}
                  onClick={(e) => this.handleMenuToggle(e)}
                  data-target="#navsitemenu"
                >
                  <Link className="tw-w-[250px] tw-h-[350px] tw-flex tw-items-center tw-justify-center tw-shrink-0" to="/productType/Abrochadoras">
                    <img className="tw-w-full tw-h-full tw-object-contain" alt="Abrochadoras" src="/img/banners/basicos-impresionismo.webp" title='comprar abrochadoras, basicos de oficina' />
                  </Link>
                </li>
              </ul>
            </li>
            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link to="/productLane/00000006">Archivo</Link>
              <ul className="mega-menu">
                <NavbarLinkSection
                  sectionText="Archivo"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Cajas Archivo"
                    url={routes.Cajas_ArchivoRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Cajas Fibra Negra"
                    url={routes.Cajas_Fibra_NegraRoute}
                    bold
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Carpeteros"
                    url={routes.CarpeterosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Ficheros"
                    url={routes.FicherosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Clasificadores"
                    url={routes.ClasificadoresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Carpetas de Presentación"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Carpetas de presentación"
                    url={routes.Carpetas_de_presentacionRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Carpetas base opaca"
                    url={routes.Carpetas_base_opacaRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Carpeta con bolsillos"
                    url={routes.Carpeta_con_bolsillosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Carpetas en L"
                    url={routes.Carpetas_en_LRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Carpetas plásticas sin anillos"
                    url={routes.Carpetas_plasticas_sin_anillosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Carpetas con vaina"
                    url={routes.Carpetas_con_vainaRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Carpetas con clip deslizable"
                    url={routes.Carpetas_con_clip_deslizableRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Carpetas Varias"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Biblioratos"
                    url={routes.BiblioratosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Lomo para biblioratos"
                    url={routes.Lomo_para_biblioratosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Carpetas internas"
                    url={routes.Carpetas_internasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Carpetas colgantes"
                    url={routes.Carpetas_colgantesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Carpetas de cartulina"
                    url={routes.Carpetas_de_cartulinaRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Carpetas con folio"
                    url={routes.Carpetas_con_folioRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Carpetas con elástico"
                    url={routes.Carpetas_con_elasticosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Carpetas con anillos"
                    url={routes.Carpetas_con_anillosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Carpetas broche Velox"
                    url={routes.Carpetas_broche_VeloxRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Carpetas broche Kismet"
                    url={routes.Carpetas_broche_KismetRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Accesorios para Carpetas"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Separadores"
                    url={routes.SeparadoresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Folios"
                    url={routes.FoliosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Índices alfabéticos A-Z"
                    url="00000020"
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Otros"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Espirales"
                    url={routes.EspiralesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tapas Anillado"
                    url={routes.Tapas_anilladoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Porta blocks"
                    url={routes.Porta_blocksRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Índice telefónico"
                    url={routes.Indice_telefonicoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Tarjeteros"
                    url={routes.TarjeterosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Repuesto tarjetero"
                    url={routes.Repuesto_tarjeteroRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Fichas"
                    url={routes.FichasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>

                <li
                  data-toggle={this.state.isMobile ? 'collapse' : null}
                  onClick={(e) => this.handleMenuToggle(e)}
                  data-target="#navsitemenu"
                >
                  <Link className="tw-w-[250px] tw-h-[350px] tw-flex tw-items-center tw-justify-center tw-shrink-0" to="/productType/Carpetas_de_presentacion">
                    <img
                      className="tw-w-full tw-h-full tw-object-contain"
                      alt="Carpetas de presentacion"
                      src="/img/banners/archivo-impresionismo.webp"
                      title='comprar carpetas de presentacion'
                    />
                  </Link>
                </li>
              </ul>
            </li>
            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link to="/productLane/00000009">Presentación</Link>
              <ul className="mega-menu">
                <NavbarLinkSection
                  sectionText="Pizarras"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Pizarra Blanca"
                    url={routes.Pizarra_blancaRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Pizarra Magnética"
                    url={routes.Pizarra_magneticaRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Pizarra de corcho"
                    url={routes.Pizarra_de_corchoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Pizarra Combinada"
                    url={routes.Pizarra_combinadaRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Rotafolios"
                    url={routes.RotafoliosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Pizarrón"
                    url={routes.PizarronRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Comunicación Visual"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Retroproyector"
                    url={routes.RetroproyectorRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Pantalla para proyección"
                    url={routes.Pantalla_para_proyeccionRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Proyector"
                    url={routes.ProyectorRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Puntero Laser"
                    url={routes.Puntero_laserRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Accesorios"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Imanes"
                    url={routes.ImanesRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Borrador"
                    url={routes.BorradorRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Transparencias"
                    url={routes.TransparenciasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <li
                  data-toggle={this.state.isMobile ? 'collapse' : null}
                  onClick={(e) => this.handleMenuToggle(e)}
                  data-target="#navsitemenu"
                >
                  <Link className="tw-w-[250px] tw-h-[350px] tw-flex tw-items-center tw-justify-center tw-shrink-0" to="/productType/Pizarra_blanca">
                    <img
                      className="tw-w-full tw-h-full tw-object-contain"
                      alt="Pizarra blanca"
                      src="/img/banners/presentacion-impresionismo.webp"
                      title='comprar pizarras'
                    />
                  </Link>
                </li>
              </ul>
            </li>
            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link to="/productLane/00000008">Electrónicos</Link>
              <ul className="mega-menu">
                <NavbarLinkSection
                  sectionText="Calculadoras y Accesorios"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Calculadoras"
                    url={routes.CalculadorasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Cintas máquinas de sumar"
                    url="00000147"
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Rodillo entintador"
                    url={routes.Rodillo_entintadorRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Rotuladoras y Accesorios"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Rotuladora"
                    url={routes.RotuladoraRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Cinta rotuladora"
                    url={routes.Cinta_rotuladoraRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Multifunción y Fax"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Multifunción"
                    url={routes.MultifuncionRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Equipo de fax"
                    url={routes.Equipo_de_faxRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Film para fax"
                    url={routes.Film_para_faxRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Destructoras y Guillotinas"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Destructora de documentos"
                    url={routes.Destructora_documentosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    bold
                  />
                  <NavbarLink
                    text="Guillotinas"
                    url={routes.GuillotinasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>

                <li
                  data-toggle={this.state.isMobile ? 'collapse' : null}
                  onClick={(e) => this.handleMenuToggle(e)}
                  data-target="#navsitemenu"
                >
                  <Link className="tw-w-[250px] tw-h-[350px] tw-flex tw-items-center tw-justify-center tw-shrink-0" to="/productType/Calculadoras">
                    <img
                      className="tw-w-full tw-h-full tw-object-contain"
                      alt="Calculadora Cifra"
                      src="/img/banners/electronicos-impresionismo.webp"
                      title='comprar productos electronicos'
                    />
                  </Link>
                </li>
              </ul>
            </li>
            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link to="/productLane/00000007">Cafetería</Link>
              <ul className="mega-menu">
                <NavbarLinkSection
                  sectionText="Café, Mate y Té"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Café"
                    url={routes.CafeRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Mate"
                    url={routes.MateRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Té"
                    url={routes.TeRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Filtro para café"
                    url={routes.Filtro_para_cafeRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Leche y Endulzantes"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Leche en polvo"
                    url={routes.Leche_en_polvoRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Azúcar"
                    url={routes.AzucarRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Edulcorante"
                    url={routes.EdulcoranteRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Accesorios"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Servilletas"
                    url={routes.ServilletasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Revolvedores"
                    url={routes.RevolvedoresRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Rollos cocina"
                    url={routes.Rollos_cocinaRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                  <NavbarLink
                    text="Vasos"
                    url={routes.VasosRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <NavbarLinkSection
                  sectionText="Galletitas"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                >
                  <NavbarLink
                    text="Galletitas"
                    url={routes.GalletitasRoute}
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                  />
                </NavbarLinkSection>
                <li
                  data-toggle={this.state.isMobile ? 'collapse' : null}
                  onClick={(e) => this.handleMenuToggle(e)}
                  data-target="#navsitemenu"
                >
                  <Link className="tw-w-[250px] tw-h-[350px] tw-flex tw-items-center tw-justify-center tw-shrink-0" to="/productType/Cafe">
                    <img className="tw-w-full tw-h-full tw-object-contain" alt="Azúcar" title='comprar productos cafeteria' src="/img/banners/cafeteria-impresionismo.webp" />
                  </Link>
                </li>
              </ul>
            </li>
            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link to="/productLane/PlanetPlus">PlanetPlus</Link>
            </li>
            <li className="has-megamenu" onClick={(e) => this.handleOpenMenuForMobile(e)}>
              <Link>Ofertas y Novedades</Link>
              <ul className="mega-menu">
                <NavbarLinkSection
                  sectionText="Ofertas y Novedades"
                  handleMenuToggle={this.handleMenuToggle}
                  isMobile={this.state.isMobile}
                  alignRight
                >
                  <NavbarLink
                    text="Ofertas"
                    url="/Ofertas"
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    alignRight
                  />
                  <NavbarLink
                    text="Novedades"
                    url="/Novedades"
                    handleMenuToggle={this.handleMenuToggle}
                    isMobile={this.state.isMobile}
                    alignRight
                  />
                </NavbarLinkSection>

                {/* <li data-toggle="collapse" data-target="#navsitemenu">
                  <Link className="tw-w-[250px] tw-h-[350px] tw-flex tw-items-center tw-justify-center tw-shrink-0" to="/Ofertas">
                    <img className="d-block mx-auto" alt="Toner HP" src="/img/categories/toner_y_cartuchos.png" />
                  </Link>
                </li> */}
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    );
  }
}

export default NavBar;
